// extracted by mini-css-extract-plugin
module.exports = {"featureWrapper":"styles__featureWrapper--318PR","title":"styles__title--3fgUj"};